<template>
  <div id="donate-blood-section" class="section-scc-portal container">
    <div id="container-page-title" style="display: flex">
      <h1>Donate Now!</h1>
    </div>
    <form id="form-donate-blood-portal-scc">
      <div class="row container-item-form" v-if="!authDonor">
        <div class="container-input-form container-input-form-left col-sm" style="margin-bottom: 25px; height: 87px;">
          <label class="label-form-css" for="new-donor-select">{{ dataSearchDonationLocation.questionNewDonor }}</label>
          <select
              class="form-control input-form-css"
              id="new-donor-select"
              v-model.trim.lazy="dataSearchDonationLocation.checkNewDonor"
          >
            <option>
              Yes
            </option>
            <option>
              No
            </option>
          </select>
        </div>
        <div class="container-input-form container-input-form-right col-sm" style="margin-bottom: 25px; height: 87px;">
          <div v-if="dataSearchDonationLocation.checkNewDonor==='Yes'?false:true">
            <label class="label-form-css" for="old-donor-email">My Email:</label>
            <input
                type="text"
                class="form-control input-form-css"
                id="old-donor-email"
                :class="{'invalid-item':objInvalid.invalidOldDonorPhone}"
                v-model.trim="dataSearchDonationLocation.emailOldDonor"
                @change="checkEmailOldDonor"
            >
            <small id="old-donor-email-small" class="form-text text-muted">Required field.</small>
          </div>
        </div>
      </div>
      <div class="row container-item-form">
        <div class="container-input-form container-input-form-left col-sm">
          <label class="label-form-css" for="zip_code_donate_blood">Zip Code:</label>
          <input
              type="text"
              class="form-control input-form-css"
              id="zip_code_donate_blood"
              :class="{'invalid-item':objInvalid.invalidEmail}"
              v-model.trim="dataSearchDonationLocation.zipCode"
          >
        </div>
        <div class="container-input-form container-input-form-right col-sm">
          <label class="label-form-css" for="my_donations_distance">Distance:</label>
          <select
              class="form-control input-form-css"
              :class="{'invalid-item':objInvalid.invalidPassword}"
              id="my_donations_distance"
              v-model.trim.lazy="dataSearchDonationLocation.distance"
          >
            <option
                v-for = "(itemDistanceOptions, indexDistanceOptions) in  distanceOptions"
                :key = 'indexDistanceOptions'
                :value ='itemDistanceOptions.value'
            >
              {{ itemDistanceOptions.banner }}
            </option>
          </select>
        </div>
      </div>
      <div class="row container-item-form" >
        <date-piker
            class="container-input-form-left"
            :class="{'invalid-item':objInvalid.dateFrom}"
            :dateDatePiker="dataSearchDonationLocation.fromData"
            nameDatePiker="Date From"
            :error-event="objInvalid.dateFrom"
        />
        <date-piker
            class="container-input-form-right"
            :class="{'invalid-item':objInvalid.dateTo}"
            :dateDatePiker="dataSearchDonationLocation.toData"
            nameDatePiker="Date To"
            :error-event="objInvalid.dateTo"
        />
      </div>
      <div class="row container-item-form">
        <div id="container-checkbox-date-donate-blood" class="form-group form-check col-sm-auto" style="text-align: start;">
          <input
              type="checkbox"
              class="form-check-input hover-pointer"
              id="donate-blood-today"
              name="donate_blood_today"
              @change="donateBloodToday"
              v-model = "dataSearchDonationLocation.todayOn"
          >
          <label class="form-check-label label-form-css" for="donate-blood-today">Today</label>
        </div>
      </div>
      <div class="row container-item-form">
        <div class="col-auto label-form-css" id="label-donation-site-type-donation-blood" ><p>Donation Site Type:</p></div>
        <div class="col-sm" id="container-box-donation-site-type" style="; padding-left: 0;">
          <div class="form-group form-check container-checkbox-donation-site-type-donation-blood" style="; padding-left: 0;">
            <label class="form-check-label label-form-css" for="donation-center-donate-blood" >Center</label>
            <input
                type="radio" id="donation-center-donate-blood"
                class="hover-pointer"
                name="donation_site_type_donate_blood"
                value="Donor_FixedSites"
                v-model="dataSearchDonationLocation.donationSiteType"
            >
          </div>
          <div class="form-group form-check container-checkbox-donation-site-type-donation-blood">
            <label class="form-check-label label-form-css" for="mobile-donate-blood">Mobile</label>
            <input
                type="radio" id="mobile-donate-blood"
                class="hover-pointer"
                name="donation_site_type_donate_blood"
                value="Donor_BloodDrives"
                v-model="dataSearchDonationLocation.donationSiteType"
            >
          </div>
          <div class="form-group form-check container-checkbox-donation-site-type-donation-blood">
            <label class="form-check-label label-form-css" for="all-donate-blood">All</label>
            <input
                type="radio" id="all-donate-blood"
                class="hover-pointer"
                name="donation_site_type_donate_blood"
                value="all"
                v-model="dataSearchDonationLocation.donationSiteType"
            >
          </div>
        </div>
      </div>
      <div class="container-item-form">
        <div id="block-mobile-code-donate-blood" class="">
          <div class="row" id="row-mobile-code-donate-blood">
            <div
                id="container-mobile-code-donate-blood"
                class="col-auto form-group form-check"
                style="padding-left: 15px;"
            >
              <input
                  type="checkbox"
                  class="hover-pointer"
                  v-model="dataSearchDonationLocation.checkMobileCode"
              >
              <label class="form-check-label label-form-css">Mobile Code:</label>
            </div>
          </div>
        </div>
        <div class="container-input-form container-input-form-left " style="">
          <input
              type="text"
              class="form-control input-form-css"
              id="mobile_code_donate_blood"
              :class="{'invalid-item':objInvalid.invalidEmail}"
              :disabled="!dataSearchDonationLocation.checkMobileCode"
              v-model.trim="dataSearchDonationLocation.mobileCode"
          >
        </div>
      </div>

      <div class="row container-item-form" style="text-align: center; width: auto">
        <button
            type="submit"
            class="button-section btn "
            value="Log In"
            :disabled="dataSearchDonationLocation.disableBtnSearchDonationLocations"
            @click.prevent="actionSearchDonationLocations"
        >
          SEARCH DONATION LOCATIONS
          <i class="fa fa-chevron-right" aria-hidden="true"></i>
        </button>
      </div>

    </form>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import datePiker from "../../elements/datePiker";
import moment from 'moment-timezone';
export default {
  name: "donateBlood",
  components: { datePiker },
  data(){
    return {
      dataSearchDonationLocation: {
        pointOfEntry: 'standard',
        zipCode: '',
        coordinates: {lat: '', lng: ''},
        distance: 5,
        fromData: moment().format('MM/DD/YYYY'),
        toData: moment().add(1, /*'M'*/ 'weeks').format('MM/DD/YYYY'),
        donationSiteType: 'all',
        checkMobileCode: false,
        mobileCode: '',
        linkMobile: '',
        disableBtnSearchDonationLocations: false,
        newDonor: true,
        checkNewDonor: 'Yes',
        questionNewDonor: 'Are you a new donor?',
        emailOldDonor: null,
      },
      objInvalid: {
        dateFrom: false,
        dateTo: false,
      },
      distanceOptions: [],
    }
  },
  computed : {
    ...mapState({
      siteCustomizationData: state => state.settingsAndCustomize.siteCustomizationData,
      crmSettings: state => state.settingsAndCustomize.crmSettings,
      authDonor: state => state.auth.authDonor,
      idDonor: state => state.donorInformation.idDonor,
      prohibitingStatuse: state => state.donorInformation.prohibitingStatuse,
      showSpinner: state => state.settingsAndCustomize.showSpinner,
    }),
  },
  async mounted() {
    let sccThis = this
    this.$root.$on('datePickerDateFrom', date => sccThis.changeFromDate(date))
    this.$root.$on('datePickerDateTo', date => sccThis.changeToDate(date))

    if( this.prohibitingStatuse === '1'){
      this.errorAlert('You are not eligible to donate. Please call the donor room, if you have questions about your eligibility.');
      this.$root.$emit("showSpinner");
      await this.$router.push({name: 'myDonations'})
      this.$root.$emit("hideSpinner");
    }
    this.$root.$emit("showSpinner");

    //Detected distance options
    this.distanceOptions = this.siteCustomizationData.appointmentsPage.distanceOptions.arrDistanceOptions;
    this.dataSearchDonationLocation.distance = this.siteCustomizationData.appointmentsPage.distanceOptions.distance;

    this.$root.$emit("hideSpinner");
  },
  methods: {
    changeFromDate(date){
      this.dataSearchDonationLocation.fromData = moment(date).format("MM/DD/YYYY");
      this.objInvalid.dateFrom = false;
    },
    changeToDate(date){
      this.dataSearchDonationLocation.toData = moment(date).format("MM/DD/YYYY");
      this.objInvalid.dateTo = false;
    },
    donateBloodToday() {
      if(this.dataSearchDonationLocation.todayOn){
        this.dataSearchDonationLocation.fromData = moment().format("MM/DD/YYYY");
        this.dataSearchDonationLocation.toData = moment().format("MM/DD/YYYY");
      } else {
        this.dataSearchDonationLocation.toData = moment(this.dataSearchDonationLocation.fromData).add(1, 'M').format("MM/DD/YYYY");
      }
    },
    async actionSearchDonationLocations(){
      if (this.dataSearchDonationLocation.checkNewDonor === 'No' &&  !this.dataSearchDonationLocation.emailOldDonor ){
        this.errorAlert(this.siteCustomizationData.messages.emailValidation);
        return
      }

      if (await this.validateDataForm()){
        this.$root.$emit("showSpinner");
        const dataDeterminationOfCoordinates ={zip: this.dataSearchDonationLocation.zipCode, lat: '', lng: ''}
        const coordinates = await this.$store.dispatch("donorInformation/SET_determinationOfCoordinates", dataDeterminationOfCoordinates )
        this.dataSearchDonationLocation.coordinates.lat = coordinates.lat
        this.dataSearchDonationLocation.coordinates.lng = coordinates.lng

        let distOption
        if (coordinates.lat === '' || coordinates.lng === '' ){
          this.$store.commit('donateBloodAppointments/set_donationLocation',  { distanceOption: '1000000000' })
          distOption = 1000000000
        } else {
          this.$store.commit('donateBloodAppointments/set_donationLocation', { distanceOption: this.dataSearchDonationLocation.distance })
          distOption = this.dataSearchDonationLocation.distance
        }
        const commitDonationLocation = {
          pointOfEntry: this.dataSearchDonationLocation.pointOfEntry,
          dateFrom: this.dataSearchDonationLocation.fromData,
          dateTo: this.dataSearchDonationLocation.toData,
          type: this.dataSearchDonationLocation.donationSiteType,
          zip: this.dataSearchDonationLocation.zipCode,
          dist: distOption,
          siteType: this.dataSearchDonationLocation.donationSiteType,
          lat: this.dataSearchDonationLocation.coordinates.lat===''?0:this.dataSearchDonationLocation.coordinates.lat,
          lng: this.dataSearchDonationLocation.coordinates.lng===''?0:this.dataSearchDonationLocation.coordinates.lng,
          checkNewDonor: this.dataSearchDonationLocation.checkNewDonor,
          emailOldDonor: this.dataSearchDonationLocation.emailOldDonor,
        }
        if (this.checkMobileCode && this.mobileCode !== ''){
          await this.$router.push({name: 'dbBookingAppointment', query: {mobile_code: this.mobileCode}})
          return
        }

        //       this.$store.commit('donorInformation/set_zipCode', this.zip)
        this.$store.commit('donateBloodAppointments/set_donationLocation', commitDonationLocation)
        const resDonationLocation = await this.$store.dispatch('donateBloodAppointments/SET_searchDonationLocation')
        this.$root.$emit("hideSpinner");

        if (this.dataSearchDonationLocation.pointOfEntry !== 'futureBookingDonation'){
          if (typeof resDonationLocation ==="undefined"){
            this.errorAlert('Error Data');
          } else if (this.dataSearchDonationLocation.checkMobileCode && this.dataSearchDonationLocation?.mobileCode !== ''){
              await this.$router.push({name: 'dbBookingAppointment', query: {mobile_code: this.dataSearchDonationLocation.mobileCode}})
          } else {
            await this.$router.push({ name: 'dbChoiceDonationLocation' })
          }
        }
      }
    },
    async validateDataForm(){
      if (!this.dataSearchDonationLocation.fromData) {
        this.errorAlert('The Date From is blank');
        this.objInvalid.dateFrom = true
        return false
      }
      if (!this.dataSearchDonationLocation.toData) {
        this.errorAlert('The Date To is blank');
        this.objInvalid.dateTo = true
        return false
      }
      if (this.dataSearchDonationLocation.fromData === 'Invalid date') {
        this.errorAlert('Invalid  Date From');
        this.objInvalid.dateFrom = true
        return false
      }
      if (this.dataSearchDonationLocation.toData === 'Invalid date') {
        this.errorAlert('Invalid  Date To');
        this.objInvalid.dateTo = true
        return false
      }
      if (!moment(moment().format('MM/DD/YYYY')).isSameOrBefore(this.dataSearchDonationLocation.fromData)) {
        this.errorAlert('Past date is not allowed');
        this.dataSearchDonationLocation.fromData = moment(this.today).format('MM/DD/YYYY');
        this.objInvalid.dateFrom = true
        return false
      }
      if (moment(this.dataSearchDonationLocation.toData).isBefore(this.dataSearchDonationLocation.fromData)) {
        this.errorAlert('From Date can not be less than To Date');
        this.dataSearchDonationLocation.toData = this.dataSearchDonationLocation.fromData
        this.objInvalid.dateFrom = this.objInvalid.dateTo = true
        return false
      }
      return true
    },
    async checkEmailOldDonor(){
      // eslint-disable-next-line no-unused-vars
      const resCheckEmailOldDonor = await this.$store.dispatch('donateBloodAppointments/SET_checkEmailOldDonor', this.dataSearchDonationLocation.emailOldDonor)
      if (resCheckEmailOldDonor.newDonor) {
        this.dataSearchDonationLocation.disableBtnSearchDonationLocations = false
      } else {
        this.dataSearchDonationLocation.disableBtnSearchDonationLocations = false
        this.checkNewDonor = 'No'
      }
    },
    errorAlert(message){
      this.$root.$emit('messageBox',
        {
          timeShow: 0,
          typeColor: "danger",
          textMessage: message,
        })
    },
    sleep: async (ms) => await new Promise(resolve => setTimeout(resolve, ms)),
  }
}
</script>

<style scoped>
#container-box-donation-site-type {
  display: flex;
/*  justify-content: start;*/
}
#label-donation-site-type-donation-blood{
  padding-left: 0;
}
#container-checkbox-date-donate-blood{
  margin-bottom: 20px;
}
.container-checkbox-donation-site-type-donation-blood input{
  margin-left: 10px;
}
#container-mobile-code-donate-blood{
  margin-bottom: 20px;
}
#container-mobile-code-donate-blood input{
 margin-right: 10px;
}
</style>
